module.exports = __webpack_public_path__ + "img/7@2x.fc93f3cc.png";